import { computed, Ref, watch } from '@vue/composition-api';

import { IssueAssembleResponse } from '../models/issue';
import { ActionStore } from './action';

export const useThirdTools = (
  actionStore: ActionStore,
  issueAssemble: Ref<IssueAssembleResponse | null>
) => {
  return {
    jenkinsStatus: computed(
      () => issueAssemble.value?.integrationIssueVO?.jenkinsStatusVO
    ),
    gitlabStatus: computed(
      () => issueAssemble.value?.integrationIssueVO?.gitLabStatusVo
    ),
    sentryStatus: computed(
      () => issueAssemble.value?.integrationIssueVO?.sentryStatusVo
    ),
    gitlabEnable: computed(
      () =>
        !!issueAssemble.value?.gitConfigVO?.find((i) => i.gitType === 0 && i.diffType === 0)
          ?.enabled
    ),
    gitHubEnable: computed(
      () =>
        !!issueAssemble.value?.gitConfigVO?.find((i) => i.gitType === 1)
          ?.enabled
    ),
    gitlabCIEnable: computed(
      () => !!(issueAssemble.value?.gitConfigVO?.find(i => i.gitType === 0 && i.diffType === 0)?.ciCdEnabled)
    )
  };
};

export type ThirdToolsStore = ReturnType<typeof useThirdTools>;
